<template>
  <div class="c-flyouts-local-store-finder-flyout">
    <template v-if="localStore !== undefined && localStore !== null && localStore?.id !== 'e_2879130'">
      <OnClickOutside
        class="local-store flyout flex flex-col border border-solid border-secondary w-full left-0 sm:left-auto sm:right-0 absolute sm:w-[350px] text-paragraph"
        @trigger="close">
        <div class="storeName items-center p-4 pt-2">
          <BasicIcon :name="'location-dot-solid'" class="w-4 text-primary" />
          <div class="grow">
            <div>{{ localStore?.name }}</div>
            <div class="text-primary cursor-pointer" @click="openStoreFinder()">Fachmarkt ändern</div>
          </div>
        </div>
        <div class="storeAdress bg-secondary items-baseline p-4 pt-2">
          <BasicIcon class="w-4 text-primary" :name="'house-chimney-solid'" />
          <div class="grow">
            {{ localStore?.street }}<br >
            {{ localStore?.zip }}
            {{ localStore?.city }}
          </div>
        </div>
        <div
          v-if="localStore?.openingHours !== undefined && localStore?.openingHours !== null && localStore?.openingHours?.length > 0"
          class="storeOpening bg-secondary items-baseline p-4 pt-0">
          <BasicIcon class="w-4 text-primary" :name="'clock-nine-regular'" />
          <div class="grid gap-1 lg:grow" style="grid-template-columns: auto auto;">
            <template v-for="range in localStore.openingHours" :key="range">
              <div style="text-transform: capitalize;">{{ range.dayFrom }}.<template v-if="range.dayFrom !== range.dayTo">
                  -
                  {{ range.dayTo }}.</template></div>
              <div>{{ range.timeFrom }} - {{ range.timeTo }} Uhr</div>
            </template>
          </div>
        </div>
        <div class="storeTelephone bg-secondary items-center p-4 pt-0">
          <BasicIcon class="w-4 text-primary" :name="'phone-solid'" />
          <div class="grow"><a class="text-primary" :href="'tel:' + localStore?.phone">{{ localStore?.phone }}</a></div>
        </div>
        <div class="storeMajorCustomerTelephone bg-secondary items-center p-4 pt-0">
          <BasicIcon class="w-4 text-primary" :name="'phone-office-solid'" />
          <div class="grow">{{ localStore?.majorCustomerPhone }}</div>
        </div>
        <div v-if="localStore?.email !== ''" class="storeEmail bg-secondary items-center p-4 pt-0">
          <BasicIcon class="w-4 text-primary" :name="'envelope-solid'" />
          <div class="grow"><a class="text-primary" :href="'mailto:' + localStore?.email">{{ localStore?.email }}</a></div>
        </div>
        <div class="storeRoute items-center p-4 pt-2">
          <BasicIcon class="w-4 text-primary" :name="'map-pin-solid'" />
          <div class="grow">
            <div>Karte & Anfahrtbeschreibung</div>
            <a class="text-primary" :href="'https://www.google.com/maps/dir/?daddr='+localStore?.street+'+'+localStore?.zip+'+'" target="_blank">Route berechnen</a>
          </div>
        </div>
        <div class="storeContact items-center p-4 pt-0">
          <BasicIcon class="w-4 text-primary" :name="'circle-info-light'" />
          <div class="grow">
            <div>Fragen? Wir helfen Ihnen gern </div>
            <a class="text-primary" href="https://www.expert.de/Footer/Service/Kontaktformular" target="_blank" rel="noopener noreferrer">Kontaktformular</a>
          </div>
        </div>
      </OnClickOutside>
    </template>
    <template v-if="localStore === undefined || localStore === null || localStore?.id === 'e_2879130'">
      <OnClickOutside class="local-store flyout flex flex-col border border-solid border-secondary w-full left-0 sm:left-auto sm:right-0 absolute sm:w-[350px]" @trigger="close">
        <div class="NoStore p-4">Kein Fachmarkt ausgewählt</div>
        <div class="noStoreButton">
          <button type="button" class="btn-primary w-full flex items-center justify-center p-4 gap-2" @click="openStoreFinder()">
            <BasicIcon :name="'location-dot-solid'" class="w-4" />Fachmarkt finden
          </button>
        </div>
      </OnClickOutside>
    </template>
  </div>
</template>
<script setup lang="ts">
import { ProvideNames } from '#shared/statics';
import { OnClickOutside } from "@vueuse/components";

const emit = defineEmits(["changeFlyOutState"]);
//FUNKTION VON FLO UND MIR VOM 25.07.23 GESEHEN VON TOBIAS AM 13.11.2025 GESEHEN VON MANUEL AM 02.07.2026
const storeRef = inject(ProvideNames.CURRENT_STORE_KEY);
const localStore = storeRef?.currentStore;

function close() {
  emit("changeFlyOutState", false);
}

function openStoreFinder() {
  close();
  usePopupQueue().enqueue({
    id: 'Storefinder',
  });
}
</script>
